import { _ } from "../../core/polyglot/polyglot.js";
import externalDocument from "./externalDocument.js";
import routeNotFoundWidget from "../../core/widgets/routeNotFoundWidget.js";

/**
 * `routeNotFoundDocument` is used when a user tries to visit a
 * page that does not exist or that he should not access.
 */
export default externalDocument.subclass((that, my) => {
	that.title = _("Page not found");

	my.routeNotFoundWidget = routeNotFoundWidget();

	that.hasActionsMenu = function () {
		return false;
	};

	my.renderContentOn = function (html) {
		html.div({ id: "document-title" }, html.h1(_("Page not found")));
		html.render(my.routeNotFoundWidget);
	};
});
